import { RegisterEbWithExistedAccountMeta, RegisterEbWithExistedAccountPayload } from 'types/store/RegisterEbWithExistedAccount';
import { createAsyncReducer } from 'utils/Redux';

import { registerEbWithExistedAccountActions } from '../actions';

export default createAsyncReducer<RegisterEbWithExistedAccountMeta, RegisterEbWithExistedAccountPayload>(registerEbWithExistedAccountActions);
